import { BackendError } from './base';

class IssueRateLimit extends BackendError {}
class ResourceVerificationExpired extends BackendError {}
class ResourceVerificationNotFound extends BackendError {}
class InvalidVerificationCode extends BackendError {}
class AttemptRateLimit extends BackendError {}
class ResourceVerificationFailed extends BackendError {}

export default {
    ResourceVerificationExpired,
    ResourceVerificationNotFound,
    InvalidVerificationCode,
    IssueRateLimit,
    AttemptRateLimit,
    ResourceVerificationFailed,
};
